var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_25_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_50_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_75_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_100_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Next"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Last"
  }), /*#__PURE__*/React.createElement("g", {
    id: "OK"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fail"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Add"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_0_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_25_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_50_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_75_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_25_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_50_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_75_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_100_x25_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Reload"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Forbidden"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clock"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Compass"
  }), /*#__PURE__*/React.createElement("g", {
    id: "World"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 50.188,
    cy: 50,
    r: 23.188
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 50.188,
    cy: 50,
    rx: 23.229,
    ry: 12.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 50.188,
    cy: 50,
    rx: 12.438,
    ry: 23.229
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 27,
    y1: 50,
    x2: 73,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 50,
    y1: 27,
    x2: 50,
    y2: 73
  })), /*#__PURE__*/React.createElement("g", {
    id: "Speed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Microphone"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Options"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chronometer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lock"
  }), /*#__PURE__*/React.createElement("g", {
    id: "User"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Position"
  }), /*#__PURE__*/React.createElement("g", {
    id: "No_x5F_Signal"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Low_x5F_Signal"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mid_x5F_Signal"
  }), /*#__PURE__*/React.createElement("g", {
    id: "High_x5F_Signal"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Options_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flash"
  }), /*#__PURE__*/React.createElement("g", {
    id: "No_x5F_Signal_x5F_02"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Low_x5F_Signal_x5F_02"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mid_x5F_Signal_x5F_02"
  }), /*#__PURE__*/React.createElement("g", {
    id: "High_x5F_Signal_x5F_02"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Favorite"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stats_x5F_01"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stats_x5F_02"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Turn_x5F_On_x5F_Off"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Full_x5F_Height"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Full_x5F_Width"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Full_x5F_Screen"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Compress_x5F_Screen"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bluetooth"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Share_x5F_iOS"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Share_x5F_Android"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Love__x2F__Favorite"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hamburguer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flying"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Take_x5F_Off"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Land"
  }), /*#__PURE__*/React.createElement("g", {
    id: "City"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nature"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pointer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Prize"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Extract"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Play"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pause"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stop"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Forward"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Reverse"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Next_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Last_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Empty_x5F_Basket"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Add_x5F_Basket"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Delete_x5F_Basket"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Error_x5F_Basket"
  }), /*#__PURE__*/React.createElement("g", {
    id: "OK_x5F_Basket"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.7f60a7fdbce7e694ab7ee292e7c4360e.svg";
export { ForwardRef as ReactComponent };